/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type InvitationCreate = {
    email: string;
    role?: InvitationCreate.role;
};

export namespace InvitationCreate {

    export enum role {
        ADMIN = 'admin',
        EDITOR = 'editor',
    }


}

